import React, { Component } from 'react';
import {Link} from 'react-router-dom';
// import Carousel from 'react-bootstrap/Carousel';
import TopSliderImages from '../../Models/TopSliderImages';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

class TopSlider extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            index: 3,
            direction: null,
            images: []
        };
        this.getSlider();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getSlider() {
        TopSliderImages.getImage().then(res => {
            console.log(res.data)
            this.setState({ images: res.data.payload })
        })
    }

    handleSelect(selectedIndex, e) {
        console.log(selectedIndex)
        this.setState({
            index: selectedIndex,
            direction: e.direction,
        });
    }

    render() {
        const responsive = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 3,
                slidesToSlide: 3, // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 500 },
                items: 2,
                slidesToSlide: 2, // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 500, min: 0 },
                items: 1,
                slidesToSlide: 1, // optional, default to 1.
            },
        };
        return(
        <div>
        {(() => {
            if (this.state.images === undefined) {
                return (
                    <div></div>
                )
            } else {
                return (
                    <div>
                        <Carousel
                            swipeable={false}
                            draggable={false}
                            // showDots={true}
                            responsive={responsive}
                            //ssr={true} // means to render carousel on server-side.
                            infinite={true}
                            autoPlay={this.props.deviceType !== "mobile" ? true : false}
                            autoPlaySpeed={5000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            containerClass="carousel-container"
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            deviceType={this.props.deviceType}
                            dotListClass="custom-dot-list-style"
                            itemClass="carousel-item-padding-40-px"
                        >
                            {this.state.images.map(imgs =>
                                <div className="" style={{ width: '98%' }} target="_blank">
                                    <a href={imgs.link} target="_blank" className="">
                                        <img
                                            className="d-block w-100"
                                            src={imgs.img}
                                            alt=""
                                            height="200px"
                                            style={{border:'1px solid #ccc'}}
                                        />
                                    </a>
                                </div>
                            )}
                        </Carousel>
                    </div>
                )
            }
        })()}
        </div>
        )
    }
}
export { TopSlider };